import { useSelector } from 'react-redux';
import { booleanPreferenceSelector } from '../../auth/selectors/auth.selectors';
import { SaveDelineation } from './SaveDelineation';
import { SaveDiagnostic } from './SaveDiagnostic';
import { SaveDiagnosticDelineation } from './SaveDiagnosticDelineation';

export const SaveButtonsBar: React.FC = () => {
  const enableSingleSave = useSelector(
    booleanPreferenceSelector('enableSingleSave'),
  );
  const allowSaveDiagnostic = useSelector(
    booleanPreferenceSelector('allowSaveDiagnostic'),
  );
  const allowSaveDelineation = useSelector(
    booleanPreferenceSelector('allowSaveDelineation'),
  );
  return (
    <>
      {enableSingleSave ? (
        <SaveDiagnosticDelineation
          allowDiagnosticSave={allowSaveDiagnostic}
          allowDelineationSave={allowSaveDelineation}
        />
      ) : (
        <>
          {allowSaveDiagnostic && <SaveDiagnostic />}
          {allowSaveDelineation && <SaveDelineation />}
        </>
      )}
    </>
  );
};
